<ng-container [formGroup]="shippingInfoForm">
  <vnm-form-field label="shipping-information.name" class="p-field-full-width">
    <input
      type="text"
      pInputText
      formControlName="name"
      [placeholder]="'shipping-information.name-placeholder' | translate"
      class="w-full"
    />
  </vnm-form-field>
  <vnm-form-field label="shipping-information.company-name" class="p-field-full-width">
    <input
      type="text"
      pInputText
      formControlName="companyName"
      [placeholder]="'app.company-placeholder' | translate"
      class="w-full"
    />
  </vnm-form-field>
  <vnm-form-field label="shipping-information.mobile-number" class="p-field-full-width">
    <p-inputMask
      class="p-field-full-width"
      formControlName="phoneNumber"
      type="tel"
      mask="(999) 999-9999"
      [placeholder]="'app.phone-placeholder' | translate"
    ></p-inputMask>
  </vnm-form-field>
  <vnm-form-field label="shipping-information.email" class="p-field-full-width">
    <input
      type="email"
      pInputText
      formControlName="email"
      [placeholder]="'shipping-information.email-placeholder' | translate"
      class="w-full"
    />
  </vnm-form-field>
</ng-container>
